/******************************************************************************
 *
 * AUTO GENERATED FILE
 *
 * DO NOT EDIT THIS FILE
 *
 * Source:
 *   controller/
 *
 * Generated:
 *   2026-07-23T20:09:05.852Z
 *
 ******************************************************************************/


/******************************************************************************/
/* 00-bootstrap.js */
/******************************************************************************/


'use strict';

(function () {

    /**
     * Prevent the controller from loading more than once.
     */
    if (window.NBHAS_CONTROLLER_LOADED) {
        console.warn('NBHAS controller is already loaded.');
        return;
    }

    window.NBHAS_CONTROLLER_LOADED = true;

    /**
     * Single NBHAS application object.
     */
    const NBHAS = window.NBHAS = window.NBHAS || {};

    Object.assign(NBHAS, {
        version: '4.0.0',

        assets: {
            leaf: window.NBHAS_LEAF_URL
        },

        masterData: null,
        engine: null,

        sections: [],
        symptoms: [],
        categories: [],
        recommendations: [],
        resources: [],

        selectedCategoryGroup: null,
        selectedAssessmentCategory: null,

       journey: {
        screen: 'category-group',
        currentSectionIndex: 0,
        activeSections: [],
        answers: {},

        totals: {
        answered: 0,
        totalScore: 0,
        sections: {}
        }
        },

        state: {
            initialized: false,
            loading: false,
            assessmentRendered: false,
            resultsRendered: false,
            handlersAttached: false
        }
    });

    const CONFIG = {
        masterJsonPath: window.NBHAS_MASTER_JSON_URL,
        analysisDelay: 2000
    };

    console.log('🚀 NBHAS Phase 4A controller loaded');
    console.log('NBHAS JSON URL:', CONFIG.masterJsonPath);
    console.log('NBHAS leaf URL:', NBHAS.assets.leaf);

/**
     * Start after the page DOM is ready.
     */
    if (document.readyState === 'loading') {
        document.addEventListener(
            'DOMContentLoaded',
            initializeNBHAS
        );
    } else {
        initializeNBHAS();
    }

    /**
     * Main application startup.
     */
    async function initializeNBHAS() {

        if (
            NBHAS.state.initialized ||
            NBHAS.state.loading
        ) {
            return;
        }

        NBHAS.state.loading = true;

        console.log('initializeNBHAS called');

        try {
            validateEnvironment();

            await loadMasterData();

            prepareJourney();

            NBHAS.state.initialized = true;

            console.log('✅ NBHAS initialization complete');
            console.log('Sections:', NBHAS.sections.length);
            console.log('Symptoms:', NBHAS.symptoms.length);
            console.log('Categories:', NBHAS.categories.length);
            console.log(
                'Recommendations:',
                NBHAS.recommendations.length
            );
            console.log('Resources:', NBHAS.resources.length);

            window.dispatchEvent(
                new CustomEvent('nbhas:ready', {
                    detail: {
                        version: NBHAS.version,
                        masterData: NBHAS.masterData
                    }
                })
            );

        } catch (error) {
            console.error(
                '❌ NBHAS initialization failed:',
                error
            );

//            showInitializationError(
//                'The hormone assessment could not be loaded. ' +
//                'Please refresh the page and try again.'
//            );

        } finally {
            NBHAS.state.loading = false;
        }
    }

    NBHAS.assets = {
        leaf: window.NBHAS_LEAF_URL
    };


/******************************************************************************/
/* 01-master-data.js */
/******************************************************************************/


/******************************************************************************
 * Environment Validation
 ******************************************************************************/

function validateEnvironment() {

    if (!CONFIG.masterJsonPath) {
        throw new Error(
            'window.NBHAS_MASTER_JSON_URL is missing.'
        );
    }

    if (typeof NBHASEngine !== 'function') {
        throw new Error(
            'NBHASEngine is not available. ' +
            'Confirm nbhas-engine.js loads before nbhas-assessment-v4.js.'
        );
    }

    const app = document.getElementById('nbhas-app');

    if (!app) {
        throw new Error(
            'The #nbhas-app container was not found.'
        );
    }
}

/******************************************************************************
 * Master Data
 ******************************************************************************/

async function loadMasterData() {

    console.log('Loading NBHAS master data...');

    const response = await fetch(
        CONFIG.masterJsonPath,
        {
            method: 'GET',
            credentials: 'same-origin',
            cache: 'no-store'
        }
    );

    if (!response.ok) {
        throw new Error(
            `Unable to load master data. HTTP ${response.status}`
        );
    }

    const masterData = await response.json();

//    validateMasterData(masterData);

    NBHAS.masterData = masterData;

    NBHAS.sections =
        Array.isArray(masterData.sections)
            ? masterData.sections
            : [];

    NBHAS.symptoms =
        Array.isArray(masterData.symptoms)
            ? masterData.symptoms
            : [];

    NBHAS.categories =
        Array.isArray(masterData.categories)
            ? masterData.categories
            : [];

    NBHAS.recommendations =
        Array.isArray(masterData.recommendations)
            ? masterData.recommendations
            : [];

    NBHAS.resources =
        Array.isArray(masterData.resources)
            ? masterData.resources
            : [];

    NBHAS.engine = new NBHASEngine(masterData);

    NBHAS.journey.activeSections = NBHAS.sections
        .filter(isActive)
        .sort(sortByDisplayOrder);

    console.log('✅ Master data loaded');
    console.log('✅ Engine created');
}



/******************************************************************************/
/* 02-journey.js */
/******************************************************************************/


/******************************************************************************
 * Journey Setup and State
 ******************************************************************************/

function prepareJourney() {

    const options = document.getElementById(
        'nb-assessment-options'
    );

    if (!options) {
        console.warn(
            'nb-assessment-options not found.'
        );
        return;
    }

    if (
        options.dataset.nbhasReady ===
        'true'
    ) {
        return;
    }

    options.dataset.nbhasReady = 'true';

    options.addEventListener(
        'click',
        handleCategoryGroupClick
    );

    console.log('✅ Journey ready');
}

/**
 * Handle the first three category-group cards already
 * rendered by the Shopify page.
 */
function handleCategoryGroupClick(event) {

    const card = event.target.closest(
        '[data-assessment-category]'
    );

    console.log('Clicked element:', event.target);
console.log('Matched card:', card);
console.log('Matched card dataset:', card?.dataset);
console.log(
    'data-assessment-category:',
    card?.getAttribute('data-assessment-category')
);

    if (!card) {
        return;
    }

    event.preventDefault();
    const categoryGroup = String(
        card.dataset.assessmentCategory || ''
    ).trim();

        console.log(
        'Resolved categoryGroup:',
        categoryGroup
    );


    if (!categoryGroup) {
        console.warn(
            'Selected group has no category value.'
        );
        return;
    }

    if (!categoryGroup) {
        console.warn(
            'Selected card has no assessment category value.',
            card
        );
        return;
    }

    NBHAS.selectedCategoryGroup = categoryGroup;
    NBHAS.selectedAssessmentCategory = null;

    console.log(
    'After assignment:',
    NBHAS.selectedCategoryGroup
);

    NBHAS.journey.currentSectionIndex = 0;
    NBHAS.journey.answers = {};

const categories =
    getAssessmentCategoriesForGroup(categoryGroup);

if (categories.length === 1) {

    const categoryID =
        categories[0].CategoryID;

    NBHAS.selectedAssessmentCategory =
        categoryID;

    NBHAS.journey.activeSections =
        buildActiveSections(categoryID);

    NBHAS.journey.currentSectionIndex = 0;

    goToSection(0);
    return;
}

if (categories.length > 1) {
    showAssessmentCategoryScreen();
    return;
}

console.error(
    'No assessment categories found for group:',
    categoryGroup
);

}

/**
 * Display the main application container and hide
 * the original category-group choices.
 */
function enterJourney() {

    const options = document.getElementById(
        'nb-assessment-options'
    );

    const app = document.getElementById(
        'nbhas-app'
    );

    if (options) {
        options.style.display = 'none';
    }

    if (app) {
        app.style.display = 'block';
    }
}

/**
 * Return to the original category-group choices.
 */
function returnToCategoryGroups() {

    const options = document.getElementById(
        'nb-assessment-options'
    );

    const app = document.getElementById(
        'nbhas-app'
    );

    NBHAS.selectedCategoryGroup = null;
    NBHAS.selectedAssessmentCategory = null;

    NBHAS.journey.screen =
        'category-group';

    NBHAS.journey.currentSectionIndex = 0;
    NBHAS.journey.answers = {};

    if (app) {
        app.innerHTML = '';
        app.style.display = 'none';
    }

    if (options) {
        options.style.display = '';

        options.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
        });
    }
}

/**
 * Move to a specific assessment section.
 */
function goToSection(sectionIndex) {

    const maxIndex =
        NBHAS.journey.activeSections.length - 1;

    const safeIndex = Math.max(
        0,
        Math.min(sectionIndex, maxIndex)
    );

    NBHAS.journey.currentSectionIndex =
        safeIndex;

    NBHAS.journey.screen = 'section';

    renderSection(safeIndex);
}

/**
 * Move to the previous journey screen.
 */
function goPrevious() {

    const currentIndex =
        NBHAS.journey.currentSectionIndex;

    if (
        NBHAS.journey.screen ===
        'results-ready'
    ) {
        goToSection(
            NBHAS.journey.activeSections.length - 1
        );
        return;
    }

    if (currentIndex > 0) {
        goToSection(currentIndex - 1);
        return;
    }

    showAssessmentCategoryScreen();
}

/**
 * Move to the next section or results review.
 */
function goNext() {

    if (!validateVisibleSection()) {
        return;
    }

    saveVisibleSectionAnswers();

    const currentIndex =
        NBHAS.journey.currentSectionIndex;

    const lastIndex =
        NBHAS.journey.activeSections.length - 1;

    if (currentIndex < lastIndex) {
        goToSection(currentIndex + 1);
        return;
    }

    showResultsReadyScreen();
}



/******************************************************************************/
/* 03-progress.js */
/******************************************************************************/


/******************************************************************************
 * Progress Bar and Milestones
 ******************************************************************************/

/**
 * Build the journey progress indicator from section data.
 */
function buildJourneyProgress(currentSectionIndex, showResultsMilestone) {

    const sections = NBHAS.journey.activeSections;

    if (!sections.length) {
        return '';
    }

    const completedThrough = showResultsMilestone
        ? sections.length
        : currentSectionIndex;

const progressPercent = showResultsMilestone
    ? 100
    : ((currentSectionIndex + 1) / (sections.length + 1)) * 100;
    const milestoneHTML = sections
        .map(function (section, index) {

            const position =
                ((index + 1) / (sections.length + 1)) * 100;

            const icon = section.Icon
                ? escapeHTML(section.Icon)
                : '';

            const sectionName = escapeHTML(
                section.SectionName
            );

            let statusClass = 'is-future';

            if (index < completedThrough) {
                statusClass = 'is-complete';
            }

            if (
                !showResultsMilestone &&
                index === currentSectionIndex
            ) {
                statusClass = 'is-current';
            }

            return `
                <div
                    class="nbhas-milestone ${statusClass}"
                    style="left: ${position}%"
                    aria-label="${sectionName}"
                    title="${sectionName}"
                >
                    <span class="nbhas-milestone-circle">
                        <span class="nbhas-milestone-icon">
                            ${icon}
                        </span>
                    </span>
                </div>
            `;
        })
        .join('');

    const resultsClass = showResultsMilestone
        ? 'is-current'
        : 'is-future';

    return `
        <div class="nbhas-journey-progress">

            <div class="nbhas-progress-track">
                <div
                    class="nbhas-progress-fill"
                    style="width: ${progressPercent}%"
                ></div>
            </div>

            <div class="nbhas-milestones">
                ${milestoneHTML}

                <div
                    class="nbhas-milestone nbhas-results-milestone ${resultsClass}"
                    style="left: 112.5%"
                    aria-label="View My Results"
                    title="View My Results"
                >
                <span class="nbhas-milestone-circle">
                    <img
                    src="${NBHAS.assets.leaf}"
                    class="nbhas-leaf-icon nbhas-leaf-icon-large"
                    alt="Results">
                </span>
              </div>
            </div>

        </div>
    `;
}



/******************************************************************************/
/* 04-category-screen.js */
/******************************************************************************/


/******************************************************************************
 * Assessment Category Screen
 ******************************************************************************/

/**
 * Show the assessment-category choices for the selected category group.
 */
function showAssessmentCategoryScreen() {
console.log(
    'Entering category screen:',
    NBHAS.selectedCategoryGroup
);
    enterJourney();

    NBHAS.journey.screen =
        'assessment-category';

    const app = document.getElementById(
        'nbhas-app'
    );

    if (!app) {
        return;
    }

    const categories = getAssessmentCategoriesForGroup(
        NBHAS.selectedCategoryGroup
    );

    if (!categories.length) {
console.error(
    '❌ Unable to load assessment category screen.',
    {
        selectedCategoryGroup:
            NBHAS.selectedCategoryGroup,

        journey:
            NBHAS.journey,

        masterData:
            NBHAS.masterData
    }
);

        return;
    }

    const categoryCards = categories
        .map(function (category) {

            const categoryID = escapeAttribute(
                category.CategoryID
            );

    const categoryName = escapeHTML(
        category.Title ||
        category.CategoryID
        );

const cleanDescription = String(
    category.Description || ''
)
    .trim()
    .replace(/^"(.*)"$/, '$1');

const categoryDescription = cleanDescription
    ? `
        <p class="nbhas-category-card-description">
            ${escapeHTML(cleanDescription)}
        </p>
    `
    : '';

            return `
                <button
                    type="button"
                    class="nbhas-category-card"
                    data-category-id="${categoryID}"
                >
                    <span class="nbhas-category-card-title">
                        ${categoryName}
                    </span>

                    ${categoryDescription}
                </button>
            `;
        })
        .join('');

    app.innerHTML = `
        <section class="nbhas-journey-screen">

            <header class="nbhas-journey-header">
                <p class="nbhas-journey-step">
                    Step 2
                </p>

                <h2>
                    Choose Your Assessment Category
                </h2>

                <p>
                    Select the option that best describes
                    your current situation.
                </p>
            </header>

            <div class="nbhas-category-grid">
                ${categoryCards}
            </div>

            <div class="nbhas-journey-navigation">
                <button
                    type="button"
                    class="nbhas-button"
                    data-journey-action="back-to-groups"
                >
                   ← Previous
                </button>
            </div>

        </section>
    `;

    attachJourneyScreenHandlers();

    app.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
    });
}

/**
 * Return categories belonging to the selected top-level group.
 *
 * DisplayCode values use the format:
 * 1-1, 1-2, 1-3
 * 2-1, 2-2, 2-3
 * 3-1, etc.
 */
function getAssessmentCategoriesForGroup(categoryGroup) {

    const categories =
        NBHAS.masterData?.categories || [];

    return categories
        .filter(function (category) {

            if (!isActive(category)) {
                return false;
            }

            const displayCode =
                String(category.DisplayCode || '').trim();

            if (categoryGroup === 'ovaries-uterus') {
                return displayCode.startsWith('1-');
            }

            if (categoryGroup === 'ovaries-no-uterus') {
                return displayCode.startsWith('2-');
            }

            if (categoryGroup === 'no-ovaries') {
                return (
                    displayCode === '3' ||
                    displayCode.startsWith('3-')
                );
            }

            return false;
        })
        .sort(function (a, b) {
            return (
                Number(a.DisplayOrder || 0) -
                Number(b.DisplayOrder || 0)
            );
        });
}

/**
 * Return only the sections containing symptoms that
 * apply to the selected assessment category.
 */
function buildActiveSections(categoryID) {

const applicableSymptomIDs = new Set(
    (NBHAS.masterData?.assessmentSymptoms || [])
        .filter(function (mapping) {
            return (
                isActive(mapping) &&
                mapping.CategoryID === categoryID
            );
        })
        .map(function (mapping) {
            return mapping.SymptomID;
        })
);

    const applicableSectionIDs = new Set(
        NBHAS.symptoms
            .filter(isActive)
            .filter(function (symptom) {
                return applicableSymptomIDs.has(
                    symptom.SymptomID
                );
            })
            .map(function (symptom) {
                return symptom.SectionID;
            })
    );

    return NBHAS.sections
        .filter(isActive)
        .filter(function (section) {
            return applicableSectionIDs.has(
                section.SectionID
            );
        })
        .sort(sortByDisplayOrder);
}

/**
 * Attach handlers for content rendered inside #nbhas-app.
 */
function attachJourneyScreenHandlers() {

    const app = document.getElementById(
        'nbhas-app'
    );

    if (
        !app ||
        NBHAS.state.handlersAttached
    ) {
        return;
    }

    app.addEventListener(
        'click',
        handleJourneyClick
    );

    app.addEventListener(
        'change',
        handleJourneyChange
    );

    NBHAS.state.handlersAttached = true;

    console.log(
        '✅ Journey screen handlers attached'
    );
}

/**
 * Handle journey navigation and category selection.
 */
function handleJourneyClick(event) {

    const categoryCard = event.target.closest(
        '[data-category-id]'
    );

    if (categoryCard) {
        event.preventDefault();

        const categoryID = String(
            categoryCard.dataset.categoryId || ''
        ).trim();

        if (!categoryID) {
            return;
        }

NBHAS.selectedAssessmentCategory =
    categoryID;

NBHAS.journey.activeSections =
    buildActiveSections(categoryID);

NBHAS.journey.currentSectionIndex = 0;

if (!NBHAS.journey.activeSections.length) {
    showAssessmentError(
        'No assessment sections are available for this category.'
    );
    return;
}

goToSection(0);
return;

    }

    const actionButton = event.target.closest(
        '[data-journey-action]'
    );

    if (!actionButton) {
        return;
    }

    event.preventDefault();

    const action =
        actionButton.dataset.journeyAction;

    if (action === 'back-to-groups') {
        returnToCategoryGroups();
        return;
    }

    if (action === 'previous') {
        goPrevious();
        return;
    }

    if (action === 'next') {
        goNext();
        return;
    }

    if (action === 'view-results') {
        completeAssessment();
    }
}

/**
 * Handle radio changes on section screens.
 */
function handleJourneyChange(event) {

    if (!event.target.matches(
        'input[type="radio"]'
    )) {
        return;
    }

    saveVisibleSectionAnswers();
    clearSectionValidationMessage();
    updateVisibleSectionSummary();
}


/******************************************************************************/
/* 05-section-screen.js */
/******************************************************************************/

/******************************************************************************
 * Section Screen
 ******************************************************************************/

/**
 * Render the currently selected assessment section.
 */
function renderSection(sectionIndex) {

    const app = document.getElementById('nbhas-app');

    if (!app) {
        return;
    }

    const sections = NBHAS.journey.activeSections;

    if (!sections.length) {
console.error(
    'No assessment sections are available for category:',
    NBHAS.selectedAssessmentCategory
);
return;
    }

    const section = sections[sectionIndex];

    if (!section) {
        showAssessmentError(
            'The requested assessment section was not found.'
        );
        return;
    }

    NBHAS.journey.screen = 'section';
    NBHAS.journey.currentSectionIndex = sectionIndex;

    const isLastSection =
        sectionIndex === sections.length - 1;

app.innerHTML = `
    <section class="nbhas-journey-screen">

        ${buildSectionHeader(section)}

        <div
            id="nbhas-section-body"
            class="nbhas-section-body"
        >
        </div>

        ${buildJourneyProgress(
            sectionIndex,
            false
        )}

        <div
            id="nbhas-section-footer"
            class="nbhas-section-footer"
        >
        </div>

    </section>
`;

renderSectionSymptoms(section);

renderSectionFooter(isLastSection);

attachJourneyScreenHandlers();

updateVisibleSectionSummary();

    app.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
    });
}

/**
 * Build the section heading.
 */
function buildSectionHeader(section) {

    const icon = escapeHTML(
        section.Icon || ''
    );

    const title = escapeHTML(
        section.SectionName
    );

    return `
        <header class="nbhas-section-header">

            <div class="nbhas-section-title">

                <span class="nbhas-section-icon">
                    ${icon}
                </span>

                <h2>
                    ${title}
                </h2>

            </div>

            <p class="nbhas-section-intro">
                Select the option that best describes
                how strongly each symptom affects you.
            </p>

            <p
                id="nbhas-visible-summary"
                class="nbhas-visible-summary"
            >
                Answered: 0&nbsp;&nbsp;Score: 0
            </p>

        </header>
    `;
}

/**
 * Return the active symptom IDs for the selected
 * assessment category.
 */
function getSelectedCategorySymptomIDs() {

    const categoryID =
        NBHAS.selectedAssessmentCategory;

    if (!categoryID) {
        return new Set();
    }

    return new Set(
        (
            NBHAS.masterData?.assessmentSymptoms ||
            []
        )
            .filter(function (mapping) {
                return (
                    isActive(mapping) &&
                    mapping.CategoryID === categoryID
                );
            })
            .sort(function (a, b) {
                return (
                    Number(a.DisplayOrder || 0) -
                    Number(b.DisplayOrder || 0)
                );
            })
            .map(function (mapping) {
                return mapping.SymptomID;
            })
    );
}

/******************************************************************************
 * Section Symptom Rendering
 ******************************************************************************/

/**
 * Render all symptoms for the current section.
 */
function renderSectionSymptoms(section) {

    const container = document.getElementById(
        'nbhas-section-body'
    );

    if (!container) {
        return;
    }

const selectedSymptomIDs =
    getSelectedCategorySymptomIDs();

const symptoms = NBHAS.symptoms
    .filter(isActive)
    .filter(function (symptom) {
        return (
            symptom.SectionID === section.SectionID &&
            selectedSymptomIDs.has(symptom.SymptomID)
        );
    })
    .sort(sortByDisplayOrder);

    if (!symptoms.length) {

        container.innerHTML = `
            <p class="nbhas-empty-section">
                No symptoms are defined for this section.
            </p>
        `;

        return;
    }

    container.innerHTML = symptoms
        .map(buildSymptomHTML)
        .join('');

    restoreVisibleSectionAnswers();
}

/**
 * Build one symptom question.
 */
function buildSymptomHTML(symptom) {

    const symptomID = escapeAttribute(
        symptom.SymptomID
    );

    const symptomName = escapeHTML(
        symptom.DisplayName
    );

    return `

    <div class="nbhas-symptom-card">
        <fieldset
            class="nbhas-symptom"
            data-symptom-id="${symptomID}"
        >

            <legend class="nbhas-symptom-name">
                ${symptomName}
            </legend>

            <div class="nbhas-answer-options">

                ${buildAnswerOption(symptomID,0,'None')}
                ${buildAnswerOption(symptomID,1,'Mild')}
                ${buildAnswerOption(symptomID,2,'Moderate')}
                ${buildAnswerOption(symptomID,3,'Severe')}

            </div>

        </fieldset>
    </div>
    `;
}

/**
 * Build one radio option.
 */
function buildAnswerOption(
    symptomID,
    value,
    label
) {

    const inputID =
        `${symptomID}-${value}`;

    return `
        <label
            class="nbhas-answer-option"
            for="${inputID}"
        >

            <input
                id="${inputID}"
                type="radio"
                name="${symptomID}"
                value="${value}"
            >

            <span>${label}</span>

        </label>
    `;
}

/**
 * Restore previously selected answers when
 * returning to a section.
 */
function restoreVisibleSectionAnswers() {

    Object.entries(
        NBHAS.journey.answers
    ).forEach(function ([symptomID,value]) {

        const radio =
            document.querySelector(

                `input[name="${cssEscape(symptomID)}"][value="${value}"]`

            );

        if (radio) {
            radio.checked = true;
        }

    });

}

/******************************************************************************
 * Section Answer State and Totals
 ******************************************************************************/

/**
 * Save all selected answers currently visible on the section screen.
 */
function saveVisibleSectionAnswers() {

    const sectionBody = document.getElementById(
        'nbhas-section-body'
    );

    if (!sectionBody) {
        return;
    }

    const selectedAnswers = sectionBody.querySelectorAll(
        'input[type="radio"]:checked'
    );

    selectedAnswers.forEach(function (radio) {

        NBHAS.journey.answers[radio.name] =
            Number(radio.value);
    });

    recalculateJourneyTotals();
}

/**
 * Recalculate all journey totals from saved answers.
 */
function recalculateJourneyTotals() {

    const totals = {
        answered: 0,
        totalScore: 0,
        sections: {}
    };

    NBHAS.journey.activeSections.forEach(
        function (section) {

            totals.sections[section.SectionID] = {
                answered: 0,
                score: 0
            };
        }
    );

    NBHAS.symptoms
        .filter(isActive)
        .forEach(function (symptom) {

            if (
                !Object.prototype.hasOwnProperty.call(
                    NBHAS.journey.answers,
                    symptom.SymptomID
                )
            ) {
                return;
            }

            const score = Number(
                NBHAS.journey.answers[symptom.SymptomID]
            );

            totals.answered += 1;
            totals.totalScore += score;

            const sectionTotals =
                totals.sections[symptom.SectionID];

            if (sectionTotals) {
                sectionTotals.answered += 1;
                sectionTotals.score += score;
            }
        });

    NBHAS.journey.totals = totals;
}

/**
 * Update the visible section summary.
 */
function updateVisibleSectionSummary() {

    saveVisibleSectionAnswers();

    const summary = document.getElementById(
        'nbhas-visible-summary'
    );

    if (!summary) {
        return;
    }

    const section =
        NBHAS.journey.activeSections[
            NBHAS.journey.currentSectionIndex
        ];

    if (!section) {
        return;
    }

    const sectionTotals =
        NBHAS.journey.totals.sections[
            section.SectionID
        ] || {
            answered: 0,
            score: 0
        };

    summary.textContent =
        `Answered: ${sectionTotals.answered}   ` +
        `Score: ${sectionTotals.score}`;
}

/******************************************************************************
 * Section Footer
 ******************************************************************************/

/**
 * Render Previous/Next controls for the visible section.
 */
function renderSectionFooter(isLastSection) {

    const footer = document.getElementById(
        'nbhas-section-footer'
    );

    if (!footer) {
        return;
    }

    const currentIndex =
        NBHAS.journey.currentSectionIndex;

    const totalSections =
        NBHAS.journey.activeSections.length;

    const nextButton = isLastSection
        ? `
            <button
                type="button"
                class="nbhas-button"
                data-journey-action="next"
            >
                Complete Assessment
            </button>
        `
        : `
            <button
                type="button"
                class="nbhas-button"
                data-journey-action="next"
            >
                Next →
            </button>
        `;

    footer.innerHTML = `
        <div class="nbhas-section-overall-progress">

            <span>
                Section ${currentIndex + 1}
                of ${totalSections}
            </span>

            <span id="nbhas-overall-answer-summary">
                Answered:
                ${NBHAS.journey.totals.answered}
                of ${getTotalActiveSymptomCount()}
            </span>

        </div>

        <div class="nbhas-journey-navigation">

            <button
                type="button"
                class="nbhas-button nbhas-previous-button"
                data-journey-action="previous"
            >
                ← Previous
            </button>

            ${nextButton}

        </div>
    `;
}

/**
 * Return the number of active symptoms in the assessment.
 */
function getTotalActiveSymptomCount() {

    return getSelectedCategorySymptomIDs().size;
}

/**
 * Refresh the overall answered count shown in the footer.
 */
function updateOverallAnswerSummary() {

    const summary = document.getElementById(
        'nbhas-overall-answer-summary'
    );

    if (!summary) {
        return;
    }

    summary.textContent =
        `Answered: ${NBHAS.journey.totals.answered} ` +
        `of ${getTotalActiveSymptomCount()}`;
}



/******************************************************************************/
/* 06-navigation.js */
/******************************************************************************/

/******************************************************************************
 * Navigation Validation
 ******************************************************************************/

/**
 * Return the currently visible section.
 */
function getCurrentSection() {

    return NBHAS.journey.activeSections[
        NBHAS.journey.currentSectionIndex
    ] || null;
}

/**
 * Return active symptoms for a section.
 */
function getSectionSymptoms(section) {

    if (!section) {
        return [];
    }

    return NBHAS.symptoms
        .filter(isActive)
        .filter(function (symptom) {
            return symptom.SectionID === section.SectionID;
        })
        .sort(sortByDisplayOrder);
}


function validateVisibleSection() {
    return true;
}
/**
 * Confirm that every symptom in the visible section has an answer. not true...
 */
function validateVisibleSectionOld() {

    saveVisibleSectionAnswers();

    const section = getCurrentSection();
    const symptoms = getSectionSymptoms(section);

    const firstUnanswered = symptoms.find(
        function (symptom) {
            return !Object.prototype.hasOwnProperty.call(
                NBHAS.journey.answers,
                symptom.SymptomID
            );
        }
    );

    clearSectionValidationMessage();

    if (!firstUnanswered) {
        return true;
    }

    showSectionValidationMessage(
        'Please answer every symptom in this section before continuing.'
    );

    const fieldset = document.querySelector(
        `[data-symptom-id="${cssEscape(firstUnanswered.SymptomID)}"]`
    );

    if (fieldset) {
        fieldset.classList.add('has-error');

        fieldset.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
        });

        const firstRadio = fieldset.querySelector(
            'input[type="radio"]'
        );

        if (firstRadio) {
            firstRadio.focus({
                preventScroll: true
            });
        }
    }

    return false;
}

/**
 * Show a section-level validation message.
 */
function showSectionValidationMessage(message) {

    const footer = document.getElementById(
        'nbhas-section-footer'
    );

    if (!footer) {
        return;
    }

    const existing = document.getElementById(
        'nbhas-section-validation'
    );

    if (existing) {
        existing.textContent = message;
        return;
    }

    footer.insertAdjacentHTML(
        'afterbegin',
        `
            <p
                id="nbhas-section-validation"
                class="nbhas-section-validation"
                role="alert"
            >
                ${escapeHTML(message)}
            </p>
        `
    );
}

/**
 * Clear previous validation styling and message.
 */
function clearSectionValidationMessage() {

    const message = document.getElementById(
        'nbhas-section-validation'
    );

    if (message) {
        message.remove();
    }

    document
        .querySelectorAll(
            '.nbhas-symptom.has-error'
        )
        .forEach(function (fieldset) {
            fieldset.classList.remove('has-error');
        });
}


/******************************************************************************/
/* 07-results.js */
/******************************************************************************/

/******************************************************************************
 * Results
 ******************************************************************************/

/**
 * Show the final journey screen before results are generated.
 */
function showResultsReadyScreen() {

    const app = document.getElementById(
        'nbhas-app'
    );

    if (!app) {
        return;
    }

    NBHAS.journey.screen = 'results-ready';

    app.innerHTML = `
        <section class="nbhas-journey-screen">

            ${buildJourneyProgress(
                NBHAS.journey.activeSections.length - 1,
                true
            )}

            <div class="nbhas-results-ready-card">

                <div class="nbhas-results-ready-icon">
                    🌿
                </div>

                <h2>
                    Your Assessment Is Complete
                </h2>

                <p>
                    We have your responses and are ready to
                    prepare <br>your personalized hormone balance results.
                </p>

                <div class="nbhas-results-ready-summary">

                    <h2>
                        Answered:
                        ${NBHAS.journey.totals.answered}
                        of ${getTotalActiveSymptomCount()}

                        Total score:
                        ${NBHAS.journey.totals.totalScore}
                    </h2>

                </div>

                <div class="nbhas-contact-card">

                    <h3>
                        Personalize Your Report
                     </h3>

                    <p>
                        <strong>
                            Optional: 
                        </strong>
                       Enter your name and email to personalize <br>your report or have your results emailed to you.
                    </p>

<div class="nbhas-form-group">

    <label for="nbhas-contact-name">
        Name
    </label>

    <input
        type="text"
        id="nbhas-contact-name"
        class="nbhas-input"
        placeholder="Your name"
    >

</div>

<div class="nbhas-form-group">

    <label for="nbhas-contact-email">
        Email
    </label>

    <input
        type="email"
        id="nbhas-contact-email"
        class="nbhas-input"
        placeholder="you@example.com"
    >

</div>

                <div class="nbhas-journey-navigation">

                    <button
                        type="button"
                        class="nbhas-button"
                        data-journey-action="previous"
                    >
                        ← Previous
                    </button>

                    <button
                        type="button"
                        class="nbhas-button"
                        data-journey-action="view-results"
                    >
                         View My Results
                    </button>

                </div>

                </div>

            </div>

        </section>
        `;

    app.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
    });
if (!NBHAS.contact) {
    NBHAS.contact = {
        name: '',
        email: ''
    };
}

const nameInput =
    document.getElementById(
        'nbhas-contact-name'
    );

const emailInput =
    document.getElementById(
        'nbhas-contact-email'
    );

if (nameInput) {

    nameInput.value =
        NBHAS.contact.name || '';

    nameInput.addEventListener(
        'input',
        event => {

            NBHAS.contact.name =
                event.target.value.trim();

        }
    );
}

if (emailInput) {

    emailInput.value =
        NBHAS.contact.email || '';

    emailInput.addEventListener(
        'input',
        event => {

            NBHAS.contact.email =
                event.target.value.trim();

        }
    );
    }
}

/**
 * Complete the assessment and send the saved answers
 * to the existing NBHAS engine.
 */
function completeAssessment() {

    saveVisibleSectionAnswers();
    recalculateJourneyTotals();

    const answers = collectAssessmentAnswers();

    const engineResults = NBHAS.engine.evaluate(
        answers.symptomAnswers
    );

    console.log(
        'Engine results:',
        engineResults
    );

    showAnalysisScreen();

    window.setTimeout(
        function () {
            renderResults(
                engineResults,
                answers
            );
        },
        CONFIG.analysisDelay
    );
}

/**
 * Build the same answer structure used by the Phase 3 controller.
 */
function collectAssessmentAnswers() {

    const answers = {
        symptomAnswers: {},
        symptoms: [],
        totalScore: 0,
        answeredCount: 0,
        sectionScores: {}
    };

    NBHAS.journey.activeSections.forEach(
        function (section) {

            answers.sectionScores[
                section.SectionID
            ] = {
                sectionName:
                    section.SectionName,
                answeredCount: 0,
                score: 0,
                symptoms: []
            };
        }
    );

    NBHAS.symptoms
        .filter(isActive)
        .forEach(function (symptom) {

            if (
                !Object.prototype.hasOwnProperty.call(
                    NBHAS.journey.answers,
                    symptom.SymptomID
                )
            ) {
                return;
            }

            const score = Number(
                NBHAS.journey.answers[
                    symptom.SymptomID
                ]
            );

            answers.symptomAnswers[
                symptom.SymptomID
            ] = score;

            answers.symptoms.push({
                symptomID:
                    symptom.SymptomID,
                symptomName:
                    symptom.DisplayName,
                sectionID:
                    symptom.SectionID,
                score: score
            });

            answers.totalScore += score;
            answers.answeredCount += 1;

            const sectionBucket =
                answers.sectionScores[
                    symptom.SectionID
                ];

            if (sectionBucket) {

                sectionBucket.answeredCount += 1;
                sectionBucket.score += score;

                sectionBucket.symptoms.push({
                    symptomID:
                        symptom.SymptomID,
                    symptomName:
                        symptom.DisplayName,
                    score: score
                });
            }
        });

    console.log(
        'Collected assessment answers:',
        answers
    );

    return answers;
}

/**
 * Show the existing analysis transition.
 */
function showAnalysisScreen() {

    const app = document.getElementById(
        'nbhas-app'
    );

    if (!app) {
        return;
    }

    NBHAS.journey.screen = 'analysis';

    app.innerHTML = `
        <section class="nbhas-analysis-screen">

        <div class="nbhas-analysis-card">

                <div class="nbhas-leaf">
                    🌿
                </div>

                <h2>
                    Understanding Your Symptoms
                </h2>

                <p>
                    We’re reviewing your answers and preparing
                    your personalized hormone balance results.
                </p>

                <div class="nbhas-analysis-progress-wrap">
                    <div class="nbhas-analysis-progress-bar"></div>
                </div>

                <p class="nbhas-analysis-note">
                    This only takes a moment.
                </p>

            </div>

        </section>
    `;
}


/**
 * Render the existing dashboard without changing
 * the engine, renderer, or dashboard implementation.
 */
function renderResults(
    engineResults,
    answers
) {

    const options = document.getElementById(
        'nb-assessment-options'
    );

    const hero = document.querySelector(
        '.nb-assessment-hero'
    );

    const beginButton = document.querySelector(
        '.nb-assessment-button'
    );

    const intro = document.querySelector(
        '.nbhas-assessment-intro-area'
    );

    const categoryHeading = document.querySelector(
        '.nbhas-category-heading'
    );

    const app = document.getElementById(
        'nbhas-app'
    );

    if (!app) {
        return;
    }

    if (beginButton) {
        beginButton.style.display = 'none';
    }

    if (intro) {
        intro.style.display = 'none';
    }

    if (categoryHeading) {
        categoryHeading.style.display = 'none';
    }

    if (options) {
        options.style.display = 'none';
    }

    app.innerHTML = `
        <div id="nbhas-results"></div>
    `;

    /*
 * Preserve the completed assessment for reporting,
 * downloading, and email delivery.
 *
 * Both Download Report and Email Results will read
 * this same object.
 */
NBHAS.completedAssessment = {
    category:
        NBHAS.selectedAssessmentCategory,

    categoryGroup:
        NBHAS.selectedCategoryGroup,

    answers:
        answers,

    results:
        engineResults,

    completedAt:
        new Date().toISOString()
};

    if (
        typeof window.renderDashboard ===
        'function'
    ) {
        window.renderDashboard(
            engineResults,
            'nbhas-results'
        );

        const editAnswersButton =
    document.getElementById(
        'nbhas-edit-answers'
    );

if (editAnswersButton) {

    editAnswersButton.addEventListener(
        'click',
        function () {

            goToSection(0);

        }
    );

}

    } else if (
        window.NBHASRenderer &&
        typeof window.NBHASRenderer.render ===
        'function'
    ) {
        window.NBHASRenderer.render(
            engineResults,
            'nbhas-results'
        );

    } else {

        console.error(
            'No NBHAS results renderer is available.'
        );

        app.innerHTML = `
            <section class="nbhas-error-screen">

                <div class="nbhas-error-card">

                    <h2>
                        Results unavailable
                    </h2>

                    <p>
                        Your assessment was completed,
                        but the results display could not
                        be loaded.
                    </p>

                </div>

            </section>
        `;

        return;
    }

    NBHAS.journey.screen = 'results';
    NBHAS.state.resultsRendered = true;

    window.dispatchEvent(
        new CustomEvent(
            'nbhas:results',
            {
                detail: {
                    category:
                        NBHAS.selectedAssessmentCategory,
                    categoryGroup:
                        NBHAS.selectedCategoryGroup,
                    answers: answers,
                    results: engineResults
                }
            }
        )
    );

    if (hero && app.parentNode) {
        hero.insertAdjacentElement(
            'afterend',
            app
        );
    }

    if (hero) {
        hero.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
        });
    } else {
        app.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
        });
    }

    console.log(
        '✅ Results rendered'
    );
}


/******************************************************************************/
/* 99-utilities.js */
/******************************************************************************/

/******************************************************************************
 * Utilities (temporary)
 ******************************************************************************/

function escapeHTML(value) {
    return String(value)
        .replaceAll('&', '&amp;')
        .replaceAll('<', '&lt;')
        .replaceAll('>', '&gt;')
        .replaceAll('"', '&quot;')
        .replaceAll("'", '&#039;');
}

function isActive(record) {
    return (
        record.Active === true ||
        String(record.Active).toUpperCase() === 'TRUE' ||
        String(record.Active) === '1'
    );
}

function sortByDisplayOrder(a, b) {
    return (
        Number(a.DisplayOrder || 0) -
        Number(b.DisplayOrder || 0)
    );
}

function escapeAttribute(value) {
    return String(value ?? '')
        .replace(/&/g, '&amp;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;');
}

function cssEscape(value) {
    const stringValue = String(value ?? '');

    if (
        window.CSS &&
        typeof window.CSS.escape === 'function'
    ) {
        return window.CSS.escape(stringValue);
    }

    return stringValue.replace(
        /[^a-zA-Z0-9_-]/g,
        character => `\\${character}`
    );
}

function showAssessmentError(message) {

    console.error(message);

    const app = document.getElementById('nbhas-app');

    if (!app) {
        return;
    }

    app.innerHTML = `
        <section class="nbhas-journey-screen">
            <div class="nbhas-error">
                <h2>Something went wrong</h2>
                <p>${escapeHTML(message)}</p>

                <button
                    type="button"
                    class="nbhas-button"
                    onclick="location.reload()">
                    Start Again
                </button>
            </div>
        </section>
    `;
}

})();

